import { bcEnums } from 'common/common/constants/boldchat-enums';
import { WorkAreaManager } from '../workitems/work-area-manager.service';
import { Renderer2 } from '@angular/core';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { Subscription } from 'rxjs';

export abstract class WidgetBase {
  public element;
  public isCannedMessagePanelOpen;
  public outsideClickHandler;
  public insideClickHandler;
  public isCannedMessagesTabActive: boolean = true;
  public isCustomTabActive: boolean = false;
  public cannedMessageFolderDropdownSubscription: Subscription;
  public abstract workItem;

  constructor(element, protected workAreaManager: WorkAreaManager, protected renderer: Renderer2, protected rxEmitter: RxEmitter) {
    this.element = element;
    this.isCannedMessagePanelOpen = false;
  }

  public isExpandedMode(): boolean {
    return this.workAreaManager.isExpandedMode();
  }

  public toggleCannedMessagePanel(): void {
    if (this.isCannedMessagePanelOpen) {
      this.closeCannedMessagePanel();
    } else {
      this.openCannedMessagePanel();
    }
  }

  public openCannedMessagePanel(activateCustomTab: boolean = false): void {
    this.isCannedMessagesTabActive = !activateCustomTab;
    this.isCustomTabActive = activateCustomTab;
    if (!this.isCannedMessagePanelOpen) {
      this.isCannedMessagePanelOpen = true;
      const widgetRect = this.element.getBoundingClientRect();
      if (widgetRect.left < widgetRect.width || widgetRect.left + 2 * widgetRect.width < window.innerWidth) {
        this._removeClassFromElement(this.element, 'right-most-item-on-screen');
      } else {
        this._addClassToElement(this.element, 'right-most-item-on-screen');
      }

      this._registerPanelCloseListeners();
      this._handleCannedMessageFolderDropdownSubscription();
      this._sendCannedMessagePanelAnalytics(bcEnums.panelAction.OPEN);
    }
  }

  public closeCannedMessagePanel(): void {
    if (this.isCannedMessagePanelOpen) {
      this.isCannedMessagePanelOpen = false;
      this.unregisterPanelCloseListeners();
      this._sendCannedMessagePanelAnalytics(bcEnums.panelAction.CLOSE);
    }
  }

  private _removeClassFromElement(element: HTMLElement, className: string): void {
    this.renderer.removeClass(element, className);
  }

  private _addClassToElement(element: HTMLElement, className: string): void {
    this.renderer.addClass(element, className);
  }

  private _registerPanelCloseListeners(): void {
    this.unregisterPanelCloseListeners();

    this.outsideClickHandler = () => {
      setTimeout(() => this.closeCannedMessagePanel());
    };
    this.insideClickHandler = (e) => {
      e.stopPropagation();
    };

    // wait for current click event's propagation
    setTimeout(() => {
      window.document.addEventListener('click', this.outsideClickHandler);
      this.element.addEventListener('click', this.insideClickHandler);
    });
  }

  public unregisterPanelCloseListeners(): void {
    if (this.outsideClickHandler) {
      window.document.removeEventListener('click', this.outsideClickHandler);
      this.element.removeEventListener('click', this.insideClickHandler);
      this.outsideClickHandler = null;
      this.insideClickHandler = null;
    }
  }

  private _handleCannedMessageFolderDropdownSubscription(): void {
    this.cannedMessageFolderDropdownSubscription = this.rxEmitter.subscribe(`${MessageBusEvents.ToggleCannedMessageFolderDropdown}${this.workItem.id}`, (value) => {
      if (value === 'open') {
        this.unregisterPanelCloseListeners();
      } else {
        this._registerPanelCloseListeners();
      }
    });
  }

  abstract _sendCannedMessagePanelAnalytics(action);
}
